import React, { useId } from "react";
import classnames from "classnames";

import { Label } from "../Label";

import "./index.scss";

export interface TextareaProps extends React.HTMLProps<HTMLTextAreaElement> {
  labelTitle?: string;
  labelClassName?: string;
  inputRef?: React.RefObject<HTMLTextAreaElement>;
  isRequired?: boolean;
}

const Textarea: React.FC<TextareaProps> = (props) => {
  const { labelTitle, labelClassName, inputRef, isRequired, ...inputProps } = props;
  // 923-core-context context/engineering/spark-rewards/phase-56-drawer-follow-ups.md #2: labelTitle rendered a <label> with no for/id link, so it never
  // became the textarea's accessible name. An explicit `id` prop wins (a caller may already rely on it
  // elsewhere, e.g. a <label for> outside this component); otherwise this generated id links the two.
  const generatedId = useId();
  const textareaId = props.id ?? generatedId;
  return (
    <div className="textarea">
      {labelTitle ? (
        <Label title={labelTitle} className={labelClassName} isRequired={isRequired} htmlFor={textareaId} />
      ) : null}
      <textarea ref={inputRef} {...inputProps} id={textareaId} className={classnames(props.className)} rows={4} />
    </div>
  );
};

export default Textarea;
